import { render, staticRenderFns } from "./typography-title.vue?vue&type=template&id=69d972f1&scoped=true"
import script from "./typography-title.vue?vue&type=script&lang=js"
export * from "./typography-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d972f1",
  null
  
)

export default component.exports